'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _require = require('./fetch'),
    fetchJson = _require.fetchJson;

var PadletAPIClient = function () {
  function PadletAPIClient(_ref) {
    var oauthToken = _ref.oauthToken,
        csrfToken = _ref.csrfToken,
        host = _ref.host,
        protocol = _ref.protocol;
    (0, _classCallCheck3.default)(this, PadletAPIClient);
    this.oauthToken = oauthToken;
    this.csrfToken = csrfToken;
    this.host = host || 'padlet.com';
    this.protocol = protocol || 'https';
  }

  (0, _createClass3.default)(PadletAPIClient, [{
    key: 'makeUrlFromEndpoint',
    value: function makeUrlFromEndpoint(endpoint) {
      return this.protocol + '://' + this.host + '/' + endpoint;
    }
  }, {
    key: 'get',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(endpoint) {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchJson(this.makeUrlFromEndpoint(endpoint), {
                  method: 'GET',
                  headers: this.defaultHeaders
                });

              case 2:
                res = _context.sent;
                return _context.abrupt('return', res.json());

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x) {
        return _ref2.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: 'post',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(endpoint, body) {
        var res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetchJson(this.makeUrlFromEndpoint(endpoint), {
                  method: 'POST',
                  headers: this.defaultHeaders,
                  body: body
                });

              case 2:
                res = _context2.sent;
                return _context2.abrupt('return', res.json());

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function post(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: 'put',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(endpoint, body) {
        var res;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return fetchJson(this.makeUrlFromEndpoint(endpoint), {
                  method: 'PUT',
                  headers: this.defaultHeaders,
                  body: body
                });

              case 2:
                res = _context3.sent;
                return _context3.abrupt('return', res.json());

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function put(_x4, _x5) {
        return _ref4.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: 'delete',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(endpoint, body) {
        var res;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return fetchJson(this.makeUrlFromEndpoint(endpoint), {
                  method: 'DELETE',
                  headers: this.defaultHeaders,
                  body: body
                });

              case 2:
                res = _context4.sent;
                return _context4.abrupt('return', res.json());

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _delete(_x6, _x7) {
        return _ref5.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: 'defaultHeaders',
    get: function get() {
      if (this.oauthToken) {
        return {
          Authorization: 'Bearer ' + this.oauthToken
        };
      } else if (this.csrfToken) {
        return {
          'X-CSRF-Token': this.csrfToken
        };
      }

      return {};
    }
  }]);
  return PadletAPIClient;
}();

module.exports = {
  PadletAPIClient: PadletAPIClient
};